"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
var _Icon = _interopRequireDefault(require("./Icon"));
exports.default = _Icon.default;